<template>
  <div id="mainContent" class="d-flex flex-column min-vh-100">

    <!--<ApplicationSkipLinks :config="ApplicationSkipLinksConfig" />
    <ApplicationHeader
      :config="ApplicationHeaderConfig"
      :menuConfig="ApplicationMenuConfig"
    />-->
    
    <div id="applicationContent">
      <slot />
    </div>

  </div>
</template>

<script>
/*import ApplicationSkipLinks from "@clir/ApplicationSkipLinks/ApplicationSkipLinks";
import ApplicationHeader from "@clir/ApplicationHeader/ApplicationHeader";

import ApplicationSkipLinksConfig from "./ApplicationSkipLinksConfig";
import ApplicationHeaderConfig from "./ApplicationHeaderConfig";*/

export default {
 /* data() {
    return {
      ApplicationSkipLinksConfig,
      ApplicationHeaderConfig,
    };
  },
  components: {
    ApplicationSkipLinks,
    ApplicationHeader,
  }*/
};
</script>

<style>
  #applicationContent {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
</style>